import type { Translation } from '../../types';
import type { addonModules as en } from '../en/addonModules';

/** Cài đặt › Module › Tiện ích: cài, bật, tắt, gỡ tiện ích; sự kiện chưa xử lý; trang của tiện ích. Lời thường, không dùng mã. */
export const addonModules: Translation<typeof en> = {
  list: {
    workerMissing: 'Trang quản trị đang không liên lạc được với các tiện ích: trang và thao tác của tiện ích chưa mở được. Cài đặt, bật, tắt và gỡ tiện ích vẫn làm được.',
    none: 'Bản cài đặt này chưa có tiện ích nào',
    noneHint: 'Tiện ích đi kèm các bản phát hành của hệ thống. Khi một bản phát hành có tiện ích, tiện ích đó hiện ở đây để cài đặt.',
    notInBuildTitle: 'Tiện ích không còn trong bản cài đặt này',
    notInBuildHint: 'Bản phát hành đã bỏ các tiện ích này nhưng hồ sơ của chúng vẫn còn: dữ liệu được giữ và khoá lại, hoặc bản sao mã hoá được giữ đến ngày ghi bên cạnh.',
    columns: { addon: 'Tiện ích', state: 'Trạng thái', data: 'Dữ liệu', updated: 'Thay đổi gần nhất' },
    back: 'Tất cả tiện ích',
    loadFailed: 'Không tải được danh sách tiện ích',
  },
  state: {
    NOT_INSTALLED: 'Chưa cài đặt',
    INSTALL_PENDING: 'Đang chờ cài đặt',
    INSTALLED: 'Đã cài, chưa bật',
    ACTIVE: 'Đang chạy',
    INACTIVE: 'Đã tắt',
    DEGRADED: 'Tạm ngừng vì lỗi',
    UNINSTALL_PENDING: 'Đang chờ gỡ',
    UNINSTALLED: 'Đã gỡ',
  },
  stateHint: {
    NOT_INSTALLED: 'Chưa cài trên máy chủ này.',
    INSTALL_PENDING: 'Đang chờ máy chủ chuẩn bị kho dữ liệu riêng cho tiện ích. Việc này chạy ở lần cập nhật hệ thống tiếp theo.',
    INSTALLED: 'Kho dữ liệu đã sẵn sàng; tiện ích chưa chạy cho đến khi được bật.',
    ACTIVE: 'Tiện ích đang nhận sự kiện, chạy việc theo lịch và hiện các trang của nó.',
    INACTIVE: 'Tiện ích không chạy; dữ liệu và cài đặt vẫn được giữ.',
    DEGRADED: 'Tiện ích lỗi liên tục nhiều lần nên đã tự dừng. Các sự kiện vẫn chờ nó.',
    UNINSTALL_PENDING: 'Đang chờ máy chủ gỡ tiện ích theo cách đã chọn. Việc này chạy ở lần cập nhật hệ thống tiếp theo.',
    UNINSTALLED: 'Đã gỡ khỏi máy chủ này.',
  },
  request: {
    install: 'Cài đặt',
    activate: 'Bật',
    deactivate: 'Tắt',
    uninstall: 'Gỡ cài đặt',
  },
  retention: {
    KEEP_DATA: 'Giữ dữ liệu',
    EXPORT_THEN_DROP: 'Giữ bản sao mã hoá rồi xoá',
    DROP: 'Xoá ngay',
  },
  retentionHint: {
    KEEP_DATA: 'Dữ liệu vẫn còn nhưng bị khoá: không ai đọc được cho đến khi cài lại tiện ích, lúc đó tiện ích dùng lại dữ liệu này.',
    EXPORT_THEN_DROP: 'Một bản sao mã hoá của mọi thứ tiện ích đã lưu được giữ trong số ngày chọn bên dưới rồi tự xoá. Bản thân dữ liệu bị xoá ngay.',
    DROP: 'Mọi thứ tiện ích đã lưu bị xoá. Không thể khôi phục.',
  },
  card: {
    version: 'Tiện ích phiên bản {{version}}',
    vendor: 'Nhà cung cấp',
    capabilities: 'Làm được gì',
    installed: 'Phiên bản đã cài',
    notInstalled: 'Chưa cài',
    settings: 'Cài đặt',
    settingsNone: 'Chưa lưu gì: tiện ích dùng giá trị mặc định.',
    settingsSaved: 'Đang dùng cài đặt đã lưu.',
    settingsDraft: 'Đã lưu nhưng chưa áp dụng.',
    settingsOpen: 'Mở cài đặt',
    settingsCreate: 'Tạo cài đặt',
    noSettings: 'Tiện ích không có cài đặt nào.',
    waiting: 'Sự kiện chưa xử lý',
    waitingNone: 'Không có.',
    waitingCount: '{{parked}} đang tạm giữ, {{retrying}} đang thử lại',
    open: 'Mở',
    notProductionReady: 'Chỉ dùng để phát triển và kiểm thử: không bao giờ cài được trên máy chủ chính thức.',
    degraded: 'Tạm ngừng vì lỗi liên tục: “{{reason}}”. Bật lại sau khi đã tìm ra nguyên nhân; các sự kiện vẫn chờ tiện ích.',
    degradedNoReason: 'Tạm ngừng vì lỗi liên tục. Bật lại sau khi đã tìm ra nguyên nhân; các sự kiện vẫn chờ tiện ích.',
    exportUntil: 'Bản sao mã hoá của dữ liệu được giữ đến {{date}}.',
    dataKept: 'Dữ liệu được giữ và đang khoá.',
    dataDropped: 'Dữ liệu đã bị xoá.',
    noRequest: 'Ở trạng thái này chưa có thao tác nào.',
  },
  approval: {
    pending: 'Đang chờ người thứ hai duyệt: {{change}}.',
    pendingSelf: 'Bạn là người đề nghị: một người khác duyệt ở trang Phê duyệt.',
    approved: 'Đã được duyệt: {{change}}. Thay đổi có hiệu lực khi có người xác nhận tại đây.',
    apply: 'Thực hiện thay đổi đã duyệt',
    open: 'Mở đề nghị',
    change: '{{request}}',
    changeWithData: '{{request}} ({{retention}})',
    changeWithDays: '{{request}} ({{retention}}, {{count}} ngày)',
  },
  dialog: {
    title: '{{request}}: {{name}}',
    install: 'Máy chủ chuẩn bị kho dữ liệu riêng cho tiện ích ở lần cập nhật hệ thống tiếp theo. Tiện ích chưa chạy cho đến khi có người bật.',
    activate: 'Tiện ích bắt đầu nhận sự kiện, chạy việc theo lịch và hiện các trang của nó.',
    activateFirst: 'Lần bật đầu tiên cho phép tiện ích đọc dữ liệu của hệ thống và thao tác trong giới hạn dành cho tiện ích.',
    deactivate: 'Mọi việc của tiện ích dừng ngay. Dữ liệu và cài đặt vẫn được giữ; sự kiện đến trong lúc tắt sẽ chờ tiện ích.',
    uninstall: 'Chọn cách xử lý dữ liệu tiện ích đã lưu. Cài đặt của tiện ích vẫn được giữ.',
    retentionDays: 'Giữ bản sao trong (ngày)',
    retentionDaysHint: 'Từ 1 đến 3650 ngày.',
    fourEyes: 'Thay đổi này cần người thứ hai duyệt rồi mới có hiệu lực.',
    fourEyesDrop: 'Xoá dữ liệu luôn cần người thứ hai duyệt.',
    noApproval: 'Thay đổi này không cần người thứ hai duyệt.',
    applyApproved: 'Một người khác đã duyệt thay đổi này. Xác nhận bây giờ để thực hiện.',
    submit: 'Gửi',
    submitForApproval: 'Gửi đề nghị duyệt',
    cancel: 'Huỷ',
    close: 'Đóng',
    requested: 'Đã gửi đề nghị. Khi một người khác duyệt (trang Phê duyệt), quay lại đây để thực hiện.',
    applied: 'Xong: tiện ích chuyển sang “{{state}}”.',
    storageStep: 'Máy chủ hoàn tất việc này ở lần cập nhật hệ thống tiếp theo.',
  },
  settingsDialog: {
    title: 'Tạo cài đặt cho {{name}}',
    description: 'Cài đặt bắt đầu từ giá trị mặc định của tiện ích. Sửa ở trang cài đặt rồi áp dụng tại đó.',
    submit: 'Tạo',
    created: 'Đã tạo. Mở trang cài đặt để sửa và áp dụng.',
  },
  events: {
    title: 'Sự kiện chưa xử lý',
    hint: 'Những sự kiện của hệ thống mà tiện ích chưa xử lý được. Sự kiện đang thử lại sẽ tự được gửi lại; sự kiện tạm giữ chờ đến khi có người gửi lại.',
    none: 'Không có sự kiện nào đang chờ.',
    filterAll: 'Tất cả',
    columns: { event: 'Sự kiện', occurred: 'Xảy ra lúc', status: 'Trạng thái', attempts: 'Số lần thử', next: 'Thử lại lúc', reason: 'Tiện ích báo' },
    status: { RETRYING: 'Đang thử lại', PARKED: 'Tạm giữ' },
    replay: 'Gửi lại',
    replayTitle: 'Gửi lại sự kiện cho tiện ích',
    replayDescription: 'Tiện ích nhận lại sự kiện này như thể nó vừa xảy ra. Nếu vẫn lỗi, sự kiện tự được thử lại.',
    replayDone: 'Đã gửi lại.',
    otherEvent: 'Sự kiện về {{what}}',
    about: {
      domain: 'tên miền',
      payment: 'thanh toán',
      order: 'đơn hàng',
      customer: 'khách hàng',
      invoice: 'hoá đơn',
      subject: 'chủ thể',
      dossier: 'hồ sơ',
      other: 'hệ thống',
    },
    loadFailed: 'Không tải được các sự kiện đang chờ',
  },
  pages: {
    title: 'Trang của tiện ích',
    notRunning: 'Tiện ích đang không chạy: bật tiện ích để mở các trang của nó.',
    none: 'Tiện ích này không có trang nào.',
    loadFailed: 'Không tải được các trang của tiện ích',
    section: 'Thuộc mục {{section}}',
    readOnly: 'Bạn chỉ xem được: thao tác trên trang tiện ích cần quyền dùng tiện ích.',
  },
  section: {
    domains: 'Tên miền',
    customers: 'Khách hàng',
    sales: 'Bán hàng',
    products: 'Sản phẩm',
    compliance: 'Tuân thủ',
    ops: 'Vận hành',
    settings: 'Cài đặt',
  },
  block: {
    loadFailed: 'Không tải được phần này',
    filter: 'Lọc',
    clear: 'Bỏ lọc',
    more: 'Tải thêm',
    empty: 'Không có dòng nào.',
    submit: 'Gửi',
    confirmTitle: 'Xác nhận',
    confirm: 'Đồng ý',
    cancel: 'Huỷ',
    dong: '{{amount}} ₫',
    yes: 'Có',
    no: 'Không',
  },
};
